/* eslint-disable camelcase */
export const bookList = Object.freeze({
    dashboard: {
        general: '/dashboard/:rest*',
        entry_point: '/dashboard/general',
        tsp_statistics: '/dashboard/tsp-statistics',
        lyt_efficiency: '/dashboard/lyt-efficiency',
    },
    auth: {
        login: '/login',
    },
    routes: {
        general: '/routes/:rest*',
        tsp_statistics: '/routes/tsp-statistics',
        reports: '/routes/reports',
        tsp_requests: '/routes/tsp-requests',
    },
    live_operations: {
        general: '/live-operations/:rest*',
        default: '/live-operations/map',
    },
    alerts: '/alerts',
    transit_insights: '/transit-insights',
    trip_analyzer: '/trip-analyzer',
    trip_tracer: '/trip-tracer',
    system_health: {
        general: '/system-health/*',
        entry_point: '/system-health/signal-network',
        signal_network: '/system-health/signal-network',
        transit_vehicle_cad_avl: '/system-health/transit-vehicle-cad-avl',
        tsp_health: '/system-health/tsp-health',
        alerts: '/system-health/alerts',
    },
    users_and_permissions: {
        general: '/users-and-permissions/:rest*',
        users: '/users-and-permissions/users',
        groups: '/users-and-permissions/groups',
        roles: '/users-and-permissions/roles',
        requests: '/users-and-permissions/requests',
    },
    team: '/team',
    requests: '/requests',
    lyt_team_management: '/lyt-team-management',

    settings: {
        profile: '/settings/profile',
        cad_avl: '/settings/cad-avl',
        notifications_and_alerts: '/settings/notifications_and_alerts',
        groups: '/settings/groups',
    },

    notFound: '/404',
    mapGL: '/map-gl',
});
